import React, { useState, useEffect, Fragment } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { fetchWrapper, toastWrapper } from '../../../../_helpers';
import { BsLock } from 'react-icons/bs';
import { BootstrapToolTip } from '../../../../_elements/ToolTip';
import { connect } from 'react-redux';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import { LoadingSpinner } from '@/_elements/Loaders';
import { VscLoading } from 'react-icons/vsc';
import { Checkbox } from '@/_elements/FormElements';

const Component = ({ currUser = {}, formId, onUpdate }) => {
    const [lockData, setLockData] = useState({ canEdit: false, canCopy: false });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const isAdmin = currUser.role === 'admin';

    useEffect(() => {
        if (showModal && formId) {
            fetchLockDetails();
        }
    }, [showModal, formId]);

    const fetchLockDetails = async () => {
        try {
            setLoading(true);
            const res = await fetchWrapper.get(`forms/form-lock/${formId}/lock`);
            setLockData(res);
        } catch (error) {
            if (error?.name === 'AbortError') return;
            toastWrapper.error(error.message || 'Failed to fetch lock details');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            await fetchWrapper.put(`forms/form-lock/${formId}/lock`, {
                canEdit: lockData.canEdit,
                canCopy: lockData.canCopy,
            });
            toastWrapper.success('Form lock settings updated');
            if (onUpdate) {
                onUpdate();
            }
            handleModalClose();
        } catch (error) {
            toastWrapper.error(error.message || 'Failed to update lock settings');
        } finally {
            setSaving(false);
        }
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleIconClick = () => {
        setShowModal(true);
    };

    return (
        <>
            {isAdmin && (
                <BootstrapToolTip text={'Lock Form'} side={'top'}>
                    <BsLock className="icon archiveIn" onClick={handleIconClick} />
                </BootstrapToolTip>
            )}

            {showModal && (
                <Modal show={showModal} onHide={handleModalClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Form Lock Settings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            {loading ? (
                                <LoadingSpinner size={48} />
                            ) : (
                                <Fragment>
                                    <Form>
                                        <Checkbox
                                            label="Lock Editing Form"
                                            value={lockData.canEdit}
                                            onChange={(checked) => {
                                                setLockData((prev) => ({
                                                    ...lockData,
                                                    canEdit: checked,
                                                }));
                                            }}
                                        />
                                        <div className="mb-3"></div>
                                        <Checkbox
                                            label="Lock Copying Form"
                                            value={lockData.canCopy}
                                            onChange={(checked) => {
                                                setLockData((prev) => ({
                                                    ...lockData,
                                                    canCopy: checked,
                                                }));
                                            }}
                                        />
                                        <div className="mb-3"></div>
                                    </Form>
                                    <div className="alert alert-info" style={{ fontSize: '1.2rem' }}>
                                        <p className="mb-0 mr-1">
                                            <strong className="mr-2">Note:</strong>Only admins can modify these
                                            settings.
                                        </p>
                                    </div>
                                </Fragment>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleSave} disabled={loading || saving}>
                            {saving && <VscLoading className="spin mr-2" />} Save Settings
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
};

const LockForm = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage || 'Failed to load Event Location Map'}>
        <Component {...props} />
    </ComponentErrorBoundary>
);
const mapStateToProps = (state) => ({
    currUser: state.user.user,
});

export default connect(mapStateToProps, {})(LockForm);
